// Basic WebSocket message types

export enum WebSocketEventType {
  // System events
  PING = 'ping',
  PONG = 'pong',

  // Authentication events
  AUTH_SUCCESS = 'auth_success',
  AUTH_FAILED = 'auth_failed',

  // Generic events - you can extend these later
  MESSAGE = 'message',
  NOTIFICATION = 'notification',
  UPDATE = 'update',
  USER_PRESENCE = 'user_presence',
  PROJECT_STATUS = 'project_status',
  MAINTENANCE_STATUS = 'maintenance_status',
  SEAT_STATUS_CHANGED = 'seat_status_changed'
}

// Basic message interfaces
export interface WSMessage<T = unknown> {
  type: string;
  data: T;
  timestamp?: number;
  id?: string;
}

// System messages
export interface PingMessage {
  type: WebSocketEventType.PING;
  data: {
    timestamp: number;
  };
}

export interface PongMessage {
  type: WebSocketEventType.PONG;
  data: {
    timestamp: number;
  };
}

// Generic message for any data
export interface GenericMessage<T = unknown> {
  type: string;
  data: T;
  timestamp?: number;
  id?: string;
}

export interface UserPresenceMessage {
  type: WebSocketEventType.USER_PRESENCE;
  data: {
    id: string;
    email: string;
    fullname?: string;
    online: boolean;
    last_seen_at: string | null;
  };
}

export interface ProjectStatusMessage {
  type: WebSocketEventType.PROJECT_STATUS;
  data: {
    id: string;
    name?: string;
    status?: number;
    status_progress?: string;
    aws_lambda_job_status?: number;
    aws_batch_job_id?: string | null;
    started_at?: string | null;
    finished_at?: string | null;
    updated_at?: string | null;
    created_at?: string | null;
    flowVersion?: number;
    action?: string;
    image?: string;
    [key: string]: string | number | boolean | null | undefined;
  };
}

export interface MaintenanceStatusMessage {
  type: WebSocketEventType.MAINTENANCE_STATUS;
  data: {
    enabled: boolean;
    updatedAt?: string | null;
  };
}

export interface SeatStatusChangedMessage {
  type: WebSocketEventType.SEAT_STATUS_CHANGED;
  data: {
    subscription_seat_active: boolean;
  };
}

